import { Module } from 'vuex';

import { NotificationsDrawerState, RootState } from 'frontend/types';
import { getJson, postData } from 'frontend/utils/ajax';
import { stringifyQueryParams } from 'frontend/utils/urls';

const notificationsDrawer: Module<NotificationsDrawerState, RootState> = {
  namespaced: true,
  state: () => ({
    notifications: [],
    end_notification_id: null,
    start_notification_id: null,
    num_extra: 0,
    num_new_notifications: 0,
  }),
  mutations: {
    setValue(state, value: NotificationsDrawerState): void {
      Object.assign(state, value);
    },
  },
  actions: {
    loadNotifications({ commit }): Promise<any> {
      return getJson('/notifications/drawer/').then((response: any) => {
        commit('setValue', response.results.notifications_drawer);
      });
    },
    dismissNotification({ commit }, notificationId: number): Promise<any> {
      const url = '/notifications/drawer/';
      const data: { form_name: string; notification_id: number } = {
        form_name: 'dismiss_individual',
        notification_id: notificationId,
      };
      return postData(url, stringifyQueryParams(data)).then((response: any) => {
        if (response.results) {
          commit('setValue', response.results.notifications_drawer);
        }
      });
    },
    dismissAllNotifications({ commit, state }): Promise<any> | void {
      if (state.start_notification_id && state.end_notification_id) {
        const url = '/notifications/drawer/';
        const data: {
          form_name: string;
          start_notification_id: number;
          end_notification_id: number;
        } = {
          form_name: 'dismiss_all',
          start_notification_id: state.start_notification_id,
          end_notification_id: state.end_notification_id,
        };
        return postData(url, stringifyQueryParams(data)).then((response: any) => {
          if (response.results) {
            commit('setValue', response.results.notifications_drawer);
          }
        });
      }
    },
  },
  getters: {
    endNotificationId: state => state.end_notification_id,
    startNotificationId: state => state.start_notification_id,
    numExtra: state => state.num_extra,
    numNewNotifications: state => state.num_new_notifications,
  },
};

export default notificationsDrawer;
